export default "__VITE_ASSET__074d9bc9__"